import Vuex from 'vuex';
import Vue from 'vue';
import gql from 'graphql-tag';

Vue.localStorage.selectedCountry = {
    type: String,
    default: null,
};

export default new Vuex.Store({
    state: {
        countries: {},
        country: null,
        loaded: false,
    },
    mutations: {
        setCountries(state, value) {
            let indexedCountries = {};

            for (let country of value) {
                indexedCountries[country.iso_2] = country;
            }

            state.countries = indexedCountries;
        },
        setCountry(state, value){
            Vue.localStorage.set('selectedCountry', value);
            state.country = value;
        },
        setLoaded(state, value) {
            state.loaded = value;
        },
    },
    getters: {
        getCountry(state) {
            return state.country;
        },
        getCountryID(state) {
            if (state.country && state.countries[state.country]){
                return state.countries[state.country].id;
            } else {
                return null;
            }
        },
        getCountryBy: state => (key ,value) => {
            let result = null;
            Object.values(state.countries).some(country => {
                if (country.hasOwnProperty(key) && country[key] === value) {
                    result = country;
                    return true;
                }
            });
            return result;
        },
        getCountryNameBy: state => (key ,value) => {
            let countryName = '';
            Object.values(state.countries).some(country => {
                if (country.hasOwnProperty(key) && country[key] === value) {
                    countryName = country.name;
                    return true;
                }
            });
            return countryName;
        },
    },
    actions: {
        loadCountries({commit}) {
            return Vue.$graphql.query({
                query: gql`
                    query getCountries {
                        getCountries {
                            id
                            name
                            isFavorite
                            iso_2
                            image_path
                            currency
                        }
                    }
                `
            }).then(
                r => r.data
            ).then(data => {
                if (data.getCountries) {
                    commit('setCountries', data.getCountries);
                }
            }).catch(
                () => {}
            );
        },
    },
});